var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendeesSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5762 7.16C18.5162 7.15 18.4462 7.15 18.3862 7.16C17.0062 7.11 15.9062 5.98 15.9062 4.58C15.9062 3.15 17.0562 2 18.4862 2C19.9162 2 21.0662 3.16 21.0662 4.58C21.0562 5.98 19.9562 7.11 18.5762 7.16Z",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5456 14.4402C18.9156 14.6702 20.4256 14.4302 21.4856 13.7202C22.8956 12.7802 22.8956 11.2402 21.4856 10.3002C20.4156 9.59016 18.8856 9.35016 17.5156 9.59016",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54469 7.16C6.60469 7.15 6.67469 7.15 6.73469 7.16C8.11469 7.11 9.21469 5.98 9.21469 4.58C9.21469 3.15 8.06469 2 6.63469 2C5.20469 2 4.05469 3.16 4.05469 4.58C4.06469 5.98 5.16469 7.11 6.54469 7.16Z",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57562 14.4402C6.20562 14.6702 4.69562 14.4302 3.63563 13.7202C2.22563 12.7802 2.22563 11.2402 3.63563 10.3002C4.70563 9.59016 6.23562 9.35016 7.60562 9.59016",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5762 14.6297C12.5162 14.6197 12.4462 14.6197 12.3862 14.6297C11.0062 14.5797 9.90625 13.4497 9.90625 12.0497C9.90625 10.6197 11.0562 9.46973 12.4862 9.46973C13.9162 9.46973 15.0662 10.6297 15.0662 12.0497C15.0562 13.4497 13.9562 14.5897 12.5762 14.6297Z",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66688 17.7794C8.25688 18.7194 8.25688 20.2594 9.66688 21.1994C11.2669 22.2694 13.8869 22.2694 15.4869 21.1994C16.8969 20.2594 16.8969 18.7194 15.4869 17.7794C13.8969 16.7194 11.2669 16.7194 9.66688 17.7794Z",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendeesSvg);
export default __webpack_public_path__ + "static/media/attendees_svg.e63ab6102abc18eb6237b711790e3367.svg";
export { ForwardRef as ReactComponent };